// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const blacephalon: PokeData = {
  "id": 806,
  "name": "blacephalon",
  "height": 18,
  "weight": 130,
  "base_experience": 257,
  "types": [
    PokeType.FIRE,
    PokeType.GHOST
  ],
  "api_moves": [
    "ember",
    "fire-spin",
    "hypnosis",
    "night-shade",
    "confuse-ray",
    "light-screen",
    "fire-blast",
    "shadow-ball",
    "will-o-wisp",
    "trick",
    "magic-coat",
    "astonish",
    "calm-mind",
    "flame-burst",
    "stored-power",
    "incinerate",
    "mystical-fire",
    "mind-blown"
  ],
  "moves": [
    "ember",
    "fire-spin",
    "night-shade",
    "confuse-ray",
    "shadow-ball",
    "calm-mind",
    "blaze-kick",
    "shadow-sneak",
    "soul-sacrifice",
    "fire-punch",
    "fire-ball",
    "sunny-day",
    "morning-sun"
  ],
  "evolution_chain": {
    "id": 426,
    "item": null,
    "species": [
      {
        "name": "blacephalon",
        "order": 806,
        "types": [
          PokeType.FIRE,
          PokeType.GHOST
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 75,
    "speed": 135,
    "ability_power": 190
  },
  "stat_changes": [],
  "catch_rate": 30,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
